const Contacto = () => (
  <div className="p-6 max-w-xl mx-auto space-y-4">
    <h2 className="text-2xl font-bold text-teal-700">Contáctanos</h2>
    <p>
      📞 <a href="tel:+59170000000">+591 77956268</a>
    </p>
    <p>
      📩 <a href="mailto:cafe@delicia.com">cafe@delicia.com</a>
    </p>
    <p>
      💬 <a href="https://wa.me/59177956268">WhatsApp</a>
    </p>
    <iframe
      className="w-full mt-4"
      src="https://www.google.com/maps/embed?pb=!1m18..."
      width="100%"
      height="250"
      loading="lazy"
    ></iframe>
  </div>
);

export default Contacto;
